export default __webpack_public_path__ + "static/media/decada-0060-0007-min.8b99fb79.jpg";